import { Injectable } from '@angular/core';

import { NotificationTypeEnum } from '@dto/notifications/notification-types.enum';
import { NotificationViewModel } from '../models/notifications.view-model';
import { APP_DOCUMENTS, APP_INVOICES, APP_MESSAGES, APP_REQUESTS_COMPLETED, APP_TASKS } from '../../config/app-urls';

export const ICON_ROOT = 'assets/icons/common/';
export const MESSAGE_ICON = 'bubble.svg';
export const DOCUMENT_ICON = 'document.svg';
export const INVOICE_ICON = 'invoice.svg';
export const TASK_ICON = 'task.svg';
export const REQUEST_ICON = 'request.svg';

@Injectable({ providedIn: 'root' })
export class NotificationConverterService {

  /**
   * Converts pre-grouped notification data from API to view model
   * API returns data already grouped by type with counts
   */
  convertGroupToViewModel(type: string, count: number): NotificationViewModel {
    const isPlural = count > 1;

    let text: string;
    let routerLinkCommands: string[];
    let icon: string;

    switch (type) {
      case NotificationTypeEnum[NotificationTypeEnum.Messages]:
        text = isPlural ? 'New Messages' : 'New Message';
        routerLinkCommands = APP_MESSAGES.toRouterLinkCommands();
        icon = ICON_ROOT + MESSAGE_ICON;
        break;
      case NotificationTypeEnum[NotificationTypeEnum.Documents]:
        text = isPlural ? 'New Documents' : 'New Document';
        routerLinkCommands = APP_DOCUMENTS.toRouterLinkCommands();
        icon = ICON_ROOT + DOCUMENT_ICON;
        break;
      case NotificationTypeEnum[NotificationTypeEnum.Invoices]:
        text = isPlural ? 'New Invoices' : 'New Invoice';
        routerLinkCommands = APP_INVOICES.toRouterLinkCommands();
        icon = ICON_ROOT + INVOICE_ICON;
        break;
      case NotificationTypeEnum[NotificationTypeEnum.Tasks]:
        text = isPlural ? 'New Tasks' : 'New Task';
        routerLinkCommands = APP_TASKS.toRouterLinkCommands();
        icon = ICON_ROOT + TASK_ICON;
        break;
      case NotificationTypeEnum[NotificationTypeEnum.Requests]:
        text = isPlural ? 'Completed Requests' : 'Completed Request';
        routerLinkCommands = APP_REQUESTS_COMPLETED.toRouterLinkCommands();
        icon = ICON_ROOT + REQUEST_ICON;
        break;
      default:
        return null;
    }

    return { id: `${type}-${count}`, type, text, routerLinkCommands, icon };
  }

}
